import * as React from 'react';
import { Menu as AntdMenu, Icon } from 'antd';
import AppRoute from '../../../Core/models/AppRoute';
import { NavLink, withRouter, RouteComponentProps, matchPath } from 'react-router-dom';
import Utility from '../../../Core/Utility';
import logo from '../../../assets/images/logo.svg';
import AuthContext from 'Context/AuthContext';
import { SlimUser } from 'Core/Api/Kopp/Api';
import { AuthUser } from 'Core/models/AuthUser';
const SubMenu = AntdMenu.SubMenu;
const MenuItemGroup = AntdMenu.ItemGroup;

export declare type MenuMode =
  | 'vertical'
  | 'vertical-left'
  | 'vertical-right'
  | 'horizontal'
  | 'inline';

export interface Props extends RouteComponentProps {
  children?: React.ReactNode;
  menu: AppRoute[];
  mode?: MenuMode;
  menuItemStyle?: React.CSSProperties;
}

export interface State { }

class AppMenuWithoutRouter extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  RenderNavLink(menu: AppRoute, fullPath: string = ''): React.ReactNode {
    if (menu.hideInMainMenu) {
      return;
    }

    return (
      <React.Fragment>
        <Icon type={menu.icon || ''} /> {menu.title}
        <NavLink to={fullPath} />
      </React.Fragment>
    );
  }

  RenderChildMenuItems(menuItems: AppRoute[], parentPath: string = ''): React.ReactNode {
    return menuItems.map((menuItem: AppRoute) => this.getMenuItem(menuItem, parentPath));
  }

  getMenuItem(menu: AppRoute, parentPath: string = ''): React.ReactNode {
    const user = this.context.data as AuthUser;
    if (menu.hideInMainMenu || !Utility.HasOperations(user, menu.requiredOperations || [])) {
      return null;
    }

    // Get full url of this link including the parent path (sub-path are always relative to parent path)
    const fullPath = Utility.combinePath(parentPath, menu.path as string);

    const onTitleClick = () => this.props.history.push(fullPath);

    // If this route is a parent route, it should be a SubMenu, else a MenuItem
    let Element: any = menu.routes ? SubMenu : AntdMenu.Item;
    //let Element: any = menu.routes && menu.routes.some(x => Utility.isSubPathVisible(x)) ? SubMenu : AntdMenu.Item;

    let clickEventHandler = menu.routes
      ? { onTitleClick: onTitleClick }
      : { onClick: onTitleClick };
    // this is added to Element that for SubMenu's we can link to the correct path

    // Setting the title for the menu (for parent-menus will have to get the icon seperately)
    const title: any = menu.routes ? this.GetTitle(menu) : menu.title;

    // Need to be aware if we are act this current path (or parent path) so as to highlight the menu item
    const matchInfo = { path: this.props.match.path, exact: true };
    const isMatch = this.CheckIfPathMatched(fullPath, matchInfo);
    const activeClass = isMatch ? 'ant-menu-item-selected' : '';

    // if menu skip, don't show this route, just render the children
    if (menu.skip) {
      return menu.routes
        ? this.RenderChildMenuItems(menu.routes as any, fullPath)
        : this.RenderNavLink(menu, fullPath);
    } else {
      return (
        <Element
          key={menu.path as string}
          title={title}
          className={activeClass}
          {...clickEventHandler}>
          {menu.routes
            ? this.RenderChildMenuItems(menu.routes as any, fullPath)
            : this.RenderNavLink(menu, fullPath)}
        </Element>
      );
    }
  }

  /**
   * Check if the path or a sub-path is the current path
   * @param path
   * @param match current location { path, exact, strict }
   */
  CheckIfPathMatched(path: any, match: any) {
    return (
      !!matchPath(path, match) || ((match.path as string).startsWith(path) && path !== match.path)
    );
  }

  /**
   * Gets the title especially if it has a icon
   *
   * @param {AppRoute} menu
   * @returns {ReactNode}
   * @memberof AppMenuWithoutRouter
   */
  GetTitle(menu: AppRoute): any {
    return (
      <React.Fragment>
        <Icon type={menu.icon || ''} /> {menu.title}
      </React.Fragment>
    );
  }

  render() {
    return (
      <AntdMenu
        overflowedIndicator={<Icon style={{ fontSize: '20px' }} type="menu" />}
        mode={this.props.mode}
        onClick={e => e.domEvent.stopPropagation()}
        theme="light">
        {this.props.menu.map(item => this.getMenuItem(item))}
      </AntdMenu>
    );
  }
}

const AppMenu = withRouter(AppMenuWithoutRouter);
export default AppMenu;
